module.exports = __webpack_public_path__ + "img/bg_i2b.392f54f5.jpg";